import React from "react";
import { observer } from "mobx-react";
import { TadManagerConfigUpdateStore } from "../../store";
import { TadManagerConfigUpdateForm } from "./TadManagerConfigUpdateForm";
import { ErrorDialog, ConfirmCancelDialog } from "../../../../common/controls";
import { SavingOverlay } from "../../../../common/controls/forms/SavingOverlay";
import { OutdatedAfterSaveNotice } from "../../../../common/controls/forms/OutdatedAfterSaveNotice";
import { TadAuthProvider } from "../../../../api/graphql";
import { IdCardType } from "../../../../api/graphql";
import { Gender } from "../../../../api/graphql";

export type TadManagerConfigUpdateProps = {
  tadManagerConfigUpdateStore: TadManagerConfigUpdateStore;
  showToolbox?: boolean;
  showSaveFooter?: boolean;
};

export const TadManagerConfigUpdate: React.FC<TadManagerConfigUpdateProps> =
  observer(
    ({ tadManagerConfigUpdateStore, showToolbox = true, showSaveFooter }) => {
      return (
        <>
          <SavingOverlay open={tadManagerConfigUpdateStore.isSaving} />
          <OutdatedAfterSaveNotice
            open={tadManagerConfigUpdateStore.savedButOutdated}
            onReload={() =>
              tadManagerConfigUpdateStore.reloadTadManagerConfig()
            }
            reloadDisabled={tadManagerConfigUpdateStore.isProcessing}
          />
          <TadManagerConfigUpdateForm
            tadManagerConfigUpdateStore={tadManagerConfigUpdateStore}
            authProviderError={
              tadManagerConfigUpdateStore.errors.authProvider?.message
            }
            authProviderOptions={tadManagerConfigUpdateStore.getAuthProviderOptions()}
            onAuthProviderChange={(value: TadAuthProvider | "") => {
              tadManagerConfigUpdateStore.setAuthProviderValue(value);
            }}
            authProvider={tadManagerConfigUpdateStore.entityValues.authProvider}
            idCardTypeError={
              tadManagerConfigUpdateStore.errors.idCardType?.message
            }
            idCardTypeOptions={tadManagerConfigUpdateStore.getIdCardTypeOptions()}
            onIdCardTypeChange={(value: IdCardType | "") => {
              tadManagerConfigUpdateStore.setIdCardTypeValue(value);
            }}
            idCardType={tadManagerConfigUpdateStore.entityValues.idCardType}
            idCardError={tadManagerConfigUpdateStore.errors.idCard?.message}
            onIdCardChange={(value: string) => {
              tadManagerConfigUpdateStore.setIdCardValue(value);
            }}
            idCard={tadManagerConfigUpdateStore.entityValues.idCard}
            procedureNumberError={
              tadManagerConfigUpdateStore.errors.procedureNumber?.message
            }
            onProcedureNumberChange={(value: string) => {
              tadManagerConfigUpdateStore.setProcedureNumberValue(value);
            }}
            procedureNumber={
              tadManagerConfigUpdateStore.entityValues.procedureNumber
            }
            miArgentinaPasswordError={
              tadManagerConfigUpdateStore.errors.miArgentinaPassword?.message
            }
            onMiArgentinaPasswordChange={(value: string) => {
              tadManagerConfigUpdateStore.setMiArgentinaPasswordValue(value);
            }}
            miArgentinaPassword={
              tadManagerConfigUpdateStore.entityValues.miArgentinaPassword
            }
            arcaPasswordError={
              tadManagerConfigUpdateStore.errors.arcaPassword?.message
            }
            onArcaPasswordChange={(value: string) => {
              tadManagerConfigUpdateStore.setArcaPasswordValue(value);
            }}
            arcaPassword={tadManagerConfigUpdateStore.entityValues.arcaPassword}
            ansesPasswordError={
              tadManagerConfigUpdateStore.errors.ansesPassword?.message
            }
            onAnsesPasswordChange={(value: string) => {
              tadManagerConfigUpdateStore.setAnsesPasswordValue(value);
            }}
            ansesPassword={
              tadManagerConfigUpdateStore.entityValues.ansesPassword
            }
            genderError={tadManagerConfigUpdateStore.errors.gender?.message}
            genderOptions={tadManagerConfigUpdateStore.getGenderOptions()}
            onGenderChange={(value: Gender | "") => {
              tadManagerConfigUpdateStore.setGenderValue(value);
            }}
            gender={tadManagerConfigUpdateStore.entityValues.gender}
            recordId={
              tadManagerConfigUpdateStore.tadManagerConfigInstance?.id || ""
            }
            showToolbox={showToolbox}
            showSaveFooter={showSaveFooter}
            saving={tadManagerConfigUpdateStore.saveDisabled}
            onSave={() => tadManagerConfigUpdateStore.saveTadManagerConfig()}
            onCancel={() =>
              tadManagerConfigUpdateStore.cancelTadManagerConfig()
            }
          />
          <ErrorDialog
            open={tadManagerConfigUpdateStore.errorDialogOpened}
            title={tadManagerConfigUpdateStore.errorTitle}
            description={tadManagerConfigUpdateStore.errorDescription}
            onClose={() => tadManagerConfigUpdateStore.closeErrorDialog()}
          />
          <ConfirmCancelDialog
            open={tadManagerConfigUpdateStore.confirmDialogOpened}
            title={tadManagerConfigUpdateStore.confirmDialogTitle}
            description={tadManagerConfigUpdateStore.confirmDialogDescription}
            onConfirm={() =>
              tadManagerConfigUpdateStore.executeConfirmedAction()
            }
            onCancel={() => tadManagerConfigUpdateStore.closeConfirmDialog()}
          />
        </>
      );
    }
  );
